import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
export function IntermediateCTA() {
  return <Section background="white" className="py-12 md:py-16 text-center" data-id="element-167">
      <Button href="https://checkout.infinita-mente.online/checkouts/cn/hWN8DLQrMRMlUOLBbsQXm56g/es-ar?_r=AQABVUqWxWx-YYE6q4IcunY9hcWfSVp5nwYN6qJAahvLEQc&cart_link_id=qAwPfsYD&preview_theme_id=138558668898" external variant="vibrant" size="xl" className="shadow-xl shadow-fuchsia-500/20" data-id="element-168">
        👉 Sí, esto es para mí
      </Button>
    </Section>;
}